import { Text } from "@mantine/core";
import { FiFrown } from 'react-icons/fi';

export const NoDataStatistics = (): JSX.Element => {
    return (
        <div className="h-full flex flex-col justify-center items-center">
            <FiFrown size={48} color="gray" />
            <Text size="lg" fw={700} mt={12} >
                Pro dané období a filtr nejsou dostupná žádná data.
            </Text>
        </div>
    );
};
